import * as Immutable from "immutable";
import WidgetConfig from "views/logic/widgets/WidgetConfig";
import Direction from "views/logic/aggregationbuilder/Direction";
import EventsWidgetSortConfig from "./EventsWidgetSortConfig";
export const LIST_MODE = "List";
export const NUMBER_MODE = "Number";
const _EventsWidgetConfig = class _EventsWidgetConfig extends WidgetConfig {
  constructor(fields, filters, sort, mode) {
    super();
    this._value = { fields, filters, sort, mode };
  }
  get fields() {
    return this._value.fields;
  }
  get filters() {
    return this._value.filters;
  }
  get sort() {
    return this._value.sort;
  }
  get mode() {
    return this._value.mode;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  toJSON() {
    const { fields = Immutable.OrderedSet(), filters = Immutable.OrderedSet(), sort, mode } = this._value;
    return {
      fields: fields.toArray(),
      filters: filters.toArray(),
      sort: sort.toJSON(),
      mode
    };
  }
  static builder() {
    return new Builder().fields(Immutable.OrderedSet()).filters(Immutable.OrderedSet());
  }
  static fromJSON(value) {
    const { fields, filters, sort, mode } = value;
    return new _EventsWidgetConfig(
      Immutable.OrderedSet(fields),
      Immutable.OrderedSet(filters),
      EventsWidgetSortConfig.fromJSON(sort),
      mode
    );
  }
  static createDefault() {
    return new _EventsWidgetConfig(
      _EventsWidgetConfig.defaultFields,
      Immutable.OrderedSet(),
      _EventsWidgetConfig.defaultSort,
      _EventsWidgetConfig.defaultMode
    );
  }
};
_EventsWidgetConfig.defaultFields = Immutable.OrderedSet([
  "message",
  "event_definition_id",
  "alert",
  "timestamp"
]);
_EventsWidgetConfig.defaultSort = new EventsWidgetSortConfig("timestamp", Direction.Descending);
_EventsWidgetConfig.defaultMode = LIST_MODE;
let EventsWidgetConfig = _EventsWidgetConfig;
export {
  EventsWidgetConfig as default
};
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  fields(value) {
    return new Builder(this.value.set("fields", value));
  }
  filters(value) {
    return new Builder(this.value.set("filters", value));
  }
  sort(value) {
    return new Builder(this.value.set("sort", value));
  }
  mode(value) {
    return new Builder(this.value.set("mode", value));
  }
  build() {
    const { fields, filters, sort, mode } = this.value.toObject();
    return new EventsWidgetConfig(fields, filters, sort, mode);
  }
}
